<template>
    <div class="container" :class="{ 'dark-mode': isDarkMode }">
      <div class="main-content" :class="{ 'with-file': uploadedFile }">
        <!-- File Upload Section - Only show when file is uploaded -->
        <div v-if="uploadedFile" class="file-upload-section">
          <FileUpload @file-uploaded="handleFileUpload" :uploadedFile="uploadedFile" />
        </div>
        
        <!-- Chat Section - Always show, but adjust width based on file presence -->
        <div class="chat-section" :class="{ 'full-width': !uploadedFile }">
          <ChatInterface :uploadedFile="uploadedFile" @file-uploaded="handleFileUpload" />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import FileUpload from '@/components/Fluidsdatapal/FileUpload.vue';
  import ChatInterface from '@/components/Fluidsdatapal/ChatInterface.vue';
  import { mapActions, mapGetters } from "vuex";
  
  export default {
    components: {
      FileUpload,
      ChatInterface,
    },
    computed: {
      ...mapGetters("darkMode", ["isDarkMode"]),
    },
    data() {
      return {
        uploadedFile: null
      };
    },
    methods: {
      ...mapActions("tenantId", ["getUserData"]),
      handleFileUpload(file) {
        this.uploadedFile = file; // Update the uploaded file (can be null when removed)
      },
    },
    mounted() {
      this.getUserData(); // Call the getUserData method from Vuex on component mount
    },
  };
  </script>
